import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TvodButtonScope, TvodButton } from './tvodButton'
import { SvodButton } from './svodButton'
import { RedeemAndPromoLink } from '../redeemAndPromoLink/redeemAndPromoLink'
import { getMoreWaysToWatchChildrenGroups } from '../../selectors/acquisitionActions'
import { isEmpty } from '../../utils/utils'
import { isSubscribeAction, isTvodAction } from '../../utils/getAcquisitionActionChildren'
import { CloseModal } from '../../utils/ModalTrigger'
import { fillValues } from 'DVWebNodeUtils'
import * as st from './moreWaysToWatchModal.module.scss'
import { ConditionalTextArray } from '../../utils/conditionalText'
import { InfoAlert, Spacing } from 'DVWebNodeUI'
import { ResponsiveImage } from '../images/responsiveImage'
import { BaseType, SrcType } from '../../utils/imageUtils'
import { LOGO_HEIGHT } from '../playbackMessaging/playbackMessaging'

const isSubsGroup = (actionGroup: WpsRuntime.atv.wps.AcquisitionActionTreeRightProps) => (
  actionGroup.children && actionGroup.children[0] && isSubscribeAction(actionGroup.children[0])
)

const GroupLabel = ({ label, sequenceNumber }: { label: string, sequenceNumber?: number }) => {
  const episodeNumber = sequenceNumber && sequenceNumber.toString() || ''
  return (
    <h3 className={st.groupLabel}>{fillValues(label, { episodeNumber })}</h3>
  )
}

const logoImgProps = {
  alt: '',
  baseValue: LOGO_HEIGHT,
  baseType: BaseType.HEIGHT,
  format: SrcType.png
}

const subsGroup = (actionGroup: WpsRuntime.atv.wps.AcquisitionActionTreeRightProps, index: number) => (
  <div key={`actionGroup-${index}`} className={st.subsGroup}>
    {actionGroup.children
      .map((action, idx) => (
        isSubscribeAction(action) &&
        isEmpty(action.problems) &&
        <div className={st.subsOffer} key={`SvodButton-${idx}`}>
          {action.image && <div> <ResponsiveImage {...logoImgProps} src={action.image} /></div>}
          {action.message && <p className={st.subMessage}>{action.message}</p>}
          <SvodButton className={st.subsButton} svodAction={action} />
        </div>
      ))}
  </div>
)

const purchaseGroup = (actionGroup: WpsRuntime.atv.wps.AcquisitionActionTreeRightProps, index: number, sequenceNumber: undefined | number, closeModal: undefined | CloseModal) => (
  <div key={`actionGroup-${index}`} className={st.purchaseGroup}>
    {actionGroup.metadata && actionGroup.metadata.label && <GroupLabel label={actionGroup.metadata.label} sequenceNumber={sequenceNumber} />}
    <ConditionalTextArray className={Spacing.base} Tag={InfoAlert} messages={actionGroup.metadata.messages} />
    {actionGroup.children
      .map((action, idx) => {
        return isTvodAction(action) && (
          <div key={`TvodButton-${idx}`} className={st.purchaseOffer}>
            <ConditionalTextArray className={Spacing.base} Tag={InfoAlert} messages={action.displayMessages} />
            <TvodButton
              tvodAction={action}
              scope={TvodButtonScope.MORE_WAYS_TO_WATCH}
              closeModal={closeModal}
            />
          </div>
        )
      })
    }
  </div>
)

type MwtwModalWithContextType = {
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
  closeModal?: CloseModal
  sequenceNumber?: number
  isMoreWaysToSubscribe?: boolean
  openGiftCardModal?: () => void
}

export const MwtwModal = ({
  moreWaysToWatch,
  closeModal,
  sequenceNumber,
  openGiftCardModal
}: MwtwModalWithContextType) => {

  if (!moreWaysToWatch) {
    return null
  }

  const mwtwChildrenGroups = getMoreWaysToWatchChildrenGroups(moreWaysToWatch)

  return isEmpty(mwtwChildrenGroups) ? null : (
    <div className={`dv-mwtw-modal ${st.modalWrapper}`}>
      {mwtwChildrenGroups.map((actionGroup: WpsRuntime.atv.wps.AcquisitionActionTreeRightProps, index: number) => (
        isSubsGroup(actionGroup)
          ? subsGroup(actionGroup, index)
          : purchaseGroup(actionGroup, index, sequenceNumber, closeModal)
      ))}
      <RedeemAndPromoLink placement={'MWTW'} closeModal={closeModal} openGiftCardModal={openGiftCardModal}/>
    </div>
  )
}

type IMoreWaysToSubscribeModal = {
  svodWinners: WpsRuntime.atv.wps.SubscribeActionTreeRightProps,
}
export const MoreWaysToSubscribeModal = ({ svodWinners }: IMoreWaysToSubscribeModal) => {
  return isEmpty(svodWinners.children) ? null : (
    <div className={`dv-mwts-modal ${st.modalWrapper}`}>
      {subsGroup(svodWinners, 0)}
    </div>
  )
}